import { IconOrganizationFilled24 } from '@gmg/gmg-react-components';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Organization } from '../../viewModels/Organization';
import OrganizationContainer from '../OrganizationContainer';
import Details from './Details';

const OrganizationManagement: FC<{}> = () => {
    const { t } = useTranslation();
    const [organization, setOrganization] = useState<Organization | undefined>(undefined);

    const details = organization && {
        address: organization.address,
        city: organization.city,
        code: organization.code,
        contactEmail: organization.contactEmail,
        contactPerson: organization.contactPerson,
        contactPhone: organization.contactPhone,
        country: organization.country,
        id: organization.id,
        name: organization.name,
        zip: organization.zip,
        isAllowedToUseLicenseSystemsOffline: organization.isAllowedToUseLicenseSystemsOffline,
    };
    return (
        <OrganizationContainer
            onOrganizationLoad={org => { setOrganization(org); }}
            viewInfo={{
                icon: <IconOrganizationFilled24 width={16} height={16} />,
                label: t('HeaderPageTitles.organization_management_title', 'Organization Management'),
            }}
        >
            <Details organization={details} />
        </OrganizationContainer >
    );
};

export default OrganizationManagement;